/**
 * do not need review have not yet been integrated
 */
import { Search, FileText, BarChart } from 'lucide-react'
import { Dialog, DialogContent } from '@/components/ui/dialog'

interface CommandPaletteProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function CommandPalette({ open, onOpenChange }: CommandPaletteProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 gap-0 max-w-2xl bg-card/95 backdrop-blur-md border border-white/15 shadow-2xl overflow-hidden">
        <div className="flex items-center px-4 py-3 border-b border-border/50">
          <Search className="h-5 w-5 text-muted-foreground mr-3" />
          <input
            className="flex-1 bg-transparent border-none outline-none text-lg placeholder:text-muted-foreground"
            placeholder="Search documents and intelligence..."
            autoFocus
          />
          <kbd className="hidden sm:inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
            <span className="text-xs">ESC</span>
          </kbd>
        </div>
        <div className="max-h-[300px] overflow-y-auto p-2">
          <div className="px-2 py-1.5 text-xs font-semibold text-muted-foreground uppercase">
            Recent
          </div>
          <div className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-secondary/50 cursor-pointer text-sm">
            <FileText className="h-4 w-4 text-primary" />
            <span>Series A Pitch Deck.pdf</span>
          </div>
          <div className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-secondary/50 cursor-pointer text-sm">
            <BarChart className="h-4 w-4 text-accent-success" />
            <span>Market Sizing Analysis</span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
